import SEO from "@/components/SEO";
import { Reveal, PractitionerCard } from "@/components/Shared";
import { HairHero, HairBreadcrumb, HairBand, HairEyebrow, HairHeading, Bullets, Paras, HairRiskPanel, HairCTABand } from "@/components/HairShared";
import { StickyCTA } from "@/components/Landing";
import { OFFERS } from "@/data/landing";
import { getTeamMember } from "@/data/content";
import { HAIR_BREADCRUMBS, HAIR_HERO, PRP_PAGE } from "@/data/hair";

const HairPrp = () => {
  const p = PRP_PAGE;
  const crumbs = HAIR_BREADCRUMBS.treatment(p.title, `/hair/treatment/${p.slug}`);
  return (
    <>
      <SEO
        title="PRP and PRF for the Scalp | Lumière Hair Clinic, Cottesloe"
        description="PRP and PRF scalp treatment in Cottesloe — your own blood, prepared and returned to the scalp to support existing follicles."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: `https://www.lumiereaesthetics.com.au${c.to}` })),
        }}
      />
      <HairHero eyebrow={p.eyebrow} title={p.title} standfirst={p.standfirst} offer={OFFERS.hair} image={HAIR_HERO.roomDetail} tall={false} testId="hair-prp-hero" />
      <HairBreadcrumb items={crumbs} />

      <HairBand narrow testId="prp-what-it-is">
        <Reveal>
          <HairEyebrow className="mb-4">What it is</HairEyebrow>
          <Paras items={p.whatItIs} />
        </Reveal>
      </HairBand>

      <HairBand dark narrow testId="prp-who-it-suits">
        <Reveal>
          <HairEyebrow className="mb-4">Who it suits — and who it doesn't</HairEyebrow>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 mt-6">
            <div>
              <h3 className="text-warm-white mb-4">It suits</h3>
              <Bullets items={p.suits} dark />
            </div>
            <div>
              <h3 className="text-warm-white mb-4">It doesn't</h3>
              <Bullets items={p.notSuits} dark />
            </div>
          </div>
        </Reveal>
      </HairBand>

      <HairBand narrow testId="prp-course">
        <Reveal>
          <HairEyebrow className="mb-4">{p.course.heading}</HairEyebrow>
          <Paras items={[p.course.body]} />
          <div className="mt-8 border-l-2 border-gold pl-8 py-2">
            <HairEyebrow className="mb-3">{p.canCannot.heading}</HairEyebrow>
            <p className="text-ink/85 leading-[1.8] text-[15px]"><span className="font-medium text-ink">It can:</span> {p.canCannot.can}</p>
            <p className="text-ink/85 leading-[1.8] text-[15px] mt-3"><span className="font-medium text-ink">It cannot:</span> {p.canCannot.cannot}</p>
          </div>
        </Reveal>
      </HairBand>

      <HairBand dark narrow testId="prp-recovery">
        <Reveal>
          <HairEyebrow className="mb-4">Recovery and aftercare</HairEyebrow>
          <div className="mt-6"><Bullets items={p.recovery} dark /></div>
        </Reveal>
      </HairBand>

      <HairBand narrow testId="prp-risks">
        <Reveal><HairRiskPanel risks={p.risks} /></Reveal>
      </HairBand>

      <HairBand dark testId="prp-practitioners">
        <Reveal>
          <HairEyebrow className="mb-6">Your practitioners</HairEyebrow>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-4 max-w-3xl">
            {p.practitioners.map((id, i) => (
              <PractitionerCard key={id} member={getTeamMember(id)} index={i} />
            ))}
          </div>
        </Reveal>
      </HairBand>

      <HairBand narrow testId="prp-pricing">
        <Reveal>
          <HairEyebrow className="mb-4">Pricing</HairEyebrow>
          <HairHeading>Published, because it can be.</HairHeading>
          <p className="text-ink/85 leading-[1.8] text-[17px] mt-6" data-testid="prp-pricing-note">{p.pricingNote}</p>
        </Reveal>
      </HairBand>

      <StickyCTA practitioner="Dr Kristy Truong" hair />
      <HairCTABand />
    </>
  );
};

export default HairPrp;
